import { useEffect, useState } from 'react';
import { api } from '../api/client';
import type { RecordsResponse } from '../api/types';

interface RecordsState {
  records: RecordsResponse | null;
  loading: boolean;
  error: string | null;
}

/** Rekorde (all-time): Serien, Bestmarken, Sozial-Rekorde. Einmal laden. */
export function useRecords(): RecordsState {
  const [state, setState] = useState<RecordsState>({ records: null, loading: true, error: null });

  useEffect(() => {
    let cancelled = false;
    api
      .get<RecordsResponse>('/stats/records')
      .then((res) => {
        if (cancelled) return;
        setState({ records: res.data, loading: false, error: null });
      })
      .catch(() => {
        if (cancelled) return;
        setState({ records: null, loading: false, error: 'Rekorde konnten nicht geladen werden' });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
